import { computed, defineComponent, getCurrentInstance } from "vue";
import { demandOrderStatusConfig } from "@pt/views/creative-service/demand-order-list/config";
import { PtButtonType, PtButtonTheme, PtButtonSize } from "@com/pt-components/pt-button/enum";
import _ from "lodash";
export default defineComponent({
    name: "OrderListTips",
    props: {
        categoryId: {
            type: Number,
            required: true
        }
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var handleClick = function(command) {
            // 跳转到工单页面
            root.$router.push({
                name: "creative-service.demand-order",
                query: {
                    search_field: "id",
                    keyword: command
                }
            });
        };
        var getOrderStatusLabel = function(row) {
            var ref;
            return (ref = demandOrderStatusConfig[row.status]) === null || ref === void 0 ? void 0 : ref.label;
        };
        var orderList = computed(function() {
            return _.get(store.state, "creative.modelOrder.orderList", []).filter(function(item) {
                return item.category_id === props.categoryId;
            });
        });
        return {
            handleClick: handleClick,
            getOrderStatusLabel: getOrderStatusLabel,
            PtButtonType: PtButtonType,
            PtButtonTheme: PtButtonTheme,
            PtButtonSize: PtButtonSize,
            orderList: orderList
        };
    }
});
